import "./button.scss";
import ReactLoading from "react-loading";
import { LoadingStatus } from "../../enums/loadingStatus";
import lightOrdarkColor from "@check-light-or-dark/color";

export enum ButtonTypes {
  OUTLINED,
  PRIMARY,
  ALERT,
  ACTION,
}

export default function Button(props: {
  className?: string;
  type: ButtonTypes;
  text: string;
  onClick?: () => void;
  isDense?: boolean;
  formButton?: boolean;
  isFullWidth?: boolean;
  maxWidth?: string;
  border?: string;
  bgColor?: string;
  fontColor?: string;
  loadingStatus?: LoadingStatus;
  fontFamily?: string;
  loadSpinColor?: string;
}) {
  let buttonStyle = "";

  switch (props.type) {
    case ButtonTypes.OUTLINED:
      buttonStyle = "buttonOutlined";
      break;
    case ButtonTypes.ALERT:
      buttonStyle = "buttonAlert";
      break;
    case ButtonTypes.ACTION:
      buttonStyle = "buttonAction";
      break;
    case ButtonTypes.PRIMARY:
      buttonStyle = "buttonPrimary";
      break;
  }

  return (
    <div
      className={["button", buttonStyle, props.className].join(" ")}
      onClick={() => props.onClick?.()}
      style={{
        fontFamily: props.fontFamily,
        border: props.border,
        color: props.bgColor
          ? lightOrdarkColor(props.bgColor) == "dark"
            ? "white"
            : "black"
          : props.fontColor,
        backgroundColor:
          props.type == ButtonTypes.OUTLINED ? "" : props.bgColor,
        maxWidth: props.maxWidth,
        width: props.isFullWidth ? "calc(100% - 3rem)" : "",
        padding: props.isDense ? "0.25rem 0.75rem 0.25rem  0.75rem" : "",
      }}
    >
      {props.loadingStatus == LoadingStatus.LOADING ? (
        <ReactLoading
          type={"spin"}
          color={
            props.loadSpinColor ?? props.bgColor
              ? lightOrdarkColor(props.bgColor!) == "dark"
                ? "white"
                : "black"
              : "white"
          }
          height={props.isDense ? 10 : 15}
          width={props.isDense ? 10 : 15}
        />
      ) : (
        props.text
      )}
    </div>
  );
}
